import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

/**
 * Validateurs de formulaire. Remplace @ff/core (validators/equals.validator.ts
 * et validators/password.validator.ts), expressions recopiees a l'identique.
 */

/**
 * Validateur de confirmation : pose sur un champ, il verifie que sa valeur est
 * egale a celle d'un autre champ du meme groupe, designe par son nom. Utilise
 * pour les confirmations de mot de passe.
 *
 *   password_confirmation: ['', [Validators.required, mpsEquals('password')]]
 *
 * Erreur renvoyee : `{ equals: { valid: false } }` (cle inchangee, les
 * templates la testent).
 *
 * A noter, present dans l'original et conserve : si le champ source est
 * introuvable, la valeur comparee est la chaine vide, donc le validateur echoue
 * au lieu de se taire. C'est sans consequence ici, les deux champs etant
 * toujours declares ensemble.
 */
export function mpsEquals(source: string): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } => {

        let value = '';
        if (control.parent && control.parent.get(source)) {
            value = control.parent.get(source).value;
        }

        return value !== control.value ? { equals: { valid: false } } : null;
    };
}

/**
 * Exige, en 8 caracteres minimum, sans espace : au moins une majuscule, une
 * minuscule, un chiffre et un caractere non alphanumerique.
 *
 * C'est le pendant cote front de la regle de mot de passe de l'API. Si l'une
 * des deux change, l'autre doit suivre, sinon le formulaire accepte un mot de
 * passe que le back refusera.
 */
export function mpsPassword(): ValidatorFn {
    return Validators.pattern(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/);
}
